module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "系统维护通知",
      "visible": _vm.dialogVisible,
      "width": "800px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "maintenance-content"
  }, [_c('div', {
    staticClass: "notice-icon"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  })]), _vm._v(" "), _c('div', {
    staticClass: "notice-text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("系统升级维护")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n          系统将于 "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.startDate))]), _vm._v(" 至 "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.endDate))]), _vm._v(" 进行升级维护。\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n          维护期间系统将无法使用，敬请谅解。\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "alert"
  }, [_c('strong', [_vm._v("温馨提示：")]), _vm._v(" 请在 "), _c('span', {
    staticClass: "highlight-red"
  }, [_vm._v(_vm._s(_vm.endDate))]), _vm._v(" 之后再进行相关操作。\n        ")])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("我已知悉")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ae798fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/home/components/maintenanceNotice.vue
// module id = 1455
// module chunks = 116